import { useTranslation } from "react-i18next";
import { Button, Flex, Icon } from "@smartfaster-ui/components";

import {
  BUTTON_ICON_NAMES,
  BUTTON_LABEL_KEYS,
  IMPLEMENTED_PANELS,
} from "./context/constants";
import { useInteriorDesigner } from "./context/InteriorDesignerContext";
import { getAvailableChips } from "./context/selectors";
import type { PanelId } from "./context/types";

export function ActionBar() {
  const { t } = useTranslation();
  const { state, dispatch } = useInteriorDesigner();
  const availableChips = getAvailableChips({ state });
  const isGenerating = state.generation.status === "loading";

  const handleButtonClick = (panelId: PanelId) => {
    if (isGenerating) {
      return;
    }
    dispatch({ type: "PANEL_OPENED", panel: panelId });
  };

  return (
    <Flex
      direction="row"
      gap="xs"
      align="center"
      justify="end"
      wrap
      pointerEvents="auto"
    >
      {availableChips.map((panelId) => (
        <Button
          key={panelId}
          variant="filled"
          color="surfaceNeutralPrimary"
          size="md"
          leading={<Icon name={BUTTON_ICON_NAMES[panelId]} />}
          onClick={() => handleButtonClick(panelId)}
          disabled={isGenerating || !IMPLEMENTED_PANELS.has(panelId)}
        >
          {t(BUTTON_LABEL_KEYS[panelId])}
        </Button>
      ))}
    </Flex>
  );
}
